// Which storage tier the paywall pre-selects.
//
// Android buyers outside the US mostly end up on 1 month anyway, and a $89
// 1-year default rarely converts there (Google Play 1-year starts paid ~2%
// outside the rich-currency markets, Sep 2026 tier study). So Android outside
// the US opens on 1 month; US Android, iOS and web keep 1 year.
//
// countryCode is BuyContext's pricing country: the store's country first, the
// device locale's region as a fallback. While it is still unknown we keep the
// 1-year default rather than guess.
export const ONE_MONTH_TIER = "events_storage_1m";
export const ONE_YEAR_TIER = "events_storage_1y";

export const defaultPaywallTier = ({ platform, countryCode } = {}) => {
  if (platform !== "android") return ONE_YEAR_TIER;
  const country =
    typeof countryCode === "string" ? countryCode.trim().toUpperCase() : "";
  if (!country) return ONE_YEAR_TIER;
  return country === "US" || country === "USA" ? ONE_YEAR_TIER : ONE_MONTH_TIER;
};
